export class Credential {
  UserName: string;
  Password: string;

  constructor(UserName: string, Password: string){
    this.UserName = UserName;
    this.Password = Password;
  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/classes/credential.ts